<div id="login" appAppPerfectScrollbar>
    <div id="login-form-wrapper">
        <div id="login-form" appIfOnDom [@animate]="{
                value: '*',
                params: { duration: '300ms', x: '-50px' }
            }">
            <div class="logo">
                <img src="../../../../../assets/images/sendo/Marca.svg" style="width: 200px; height: 200px" />
            </div>
            @if (!isRecoveryRequestSent) {
            <div>
                <form name="loginForm" [formGroup]="recoveryRequestForm" novalidate>
                    <div class="label-container">
                        <mat-label>Email</mat-label>
                    </div>

                    @if (userEmailNotFound) {
                    <div class="alert alert-danger alert-padding">
                        <span class="text-danger">
                            No se encontró un usuario con el correo electrónico ingresado
                        </span>
                    </div>
                    }
                    <mat-form-field appearance="fill">
                        <mat-icon matPrefix>
                            <span class="material-symbols-outlined">
                                person
                            </span>
                        </mat-icon>

                        <input matInput placeholder="Ingrese su email" formControlName="email" />
                        <!-- <mat-error *ngIf="loginFormErrors.userName.required">
                        El usuario es requerido
                    </mat-error> -->
                    </mat-form-field>
                    <div class="login-buttons-container">
                        <button mat-raised-button class="submit-button" aria-label="LOG IN" [disabled]="disableButton()"
                            (click)="sendRecoveryRequest()">
                            <i *ngIf="isWaiting" style="font-size: 21px; color: white !important"
                                class="fa fa-refresh fa-spin"></i>
                            <div fxLayoutAlign="center center" *ngIf="!isWaiting">
                                <span class="button-logo material-symbols-outlined">
                                    lock_reset
                                </span>
                                <span>Solicitar Recuperación</span>
                            </div>
                        </button>
                    </div>
                </form>
                <div class="register" fxLayout="column" fxLayoutAlign="center center">
                    <span class="text">Ya tienes una cuenta?</span>
                    <a class="link" translate [routerLink]="'/login'">Ingresar</a>
                </div>
            </div>
            }

            @if (isRecoveryRequestSent) {
            <div class="success-message-container">
                <div class="success-message d-flex flex-column">
                    <div class="alert alert-success d-flex flex-column">
                        <span class="fs-4">Su solicitud de recuperación ha sido enviada</span>
                        <a class="fs-4 link" translate [routerLink]="'/login'">Ingresar</a>
                    </div>

                </div>
            </div>
            }
        </div>
    </div>
</div>